import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { FC } from "react";

export const AsideButton: FCX<{
    title: string;
    testId?: string;
    icon?: FC<{ className?: string }>;
    onClick?: () => void;
    isDisabled?: boolean;
}> = ({
    title,
    icon: Icon,
    isDisabled,
    onClick,
    className,
    style,
    testId
}) => {
    return (
        <div
            className={cn(
                "AsideButton",
                className,
                isDisabled && "is-disabled",
            )}
            style={style}
            onClick={onClick}
            data-testid={testId}
        >
            {!!Icon && <Icon className="AsideButton__icon"/>}
            {title}
        </div>
    );
}

const AsideButtons: FCX = ({
    className,
    style,
    children,
}) => {
    return (
        <div
            className={cn("AsideButtons", className)}
            style={style}
        >
            {children}
        </div>
    );
};

export default AsideButtons;